<template>
    <div>
        <el-steps style="margin-bottom:85px" class="applystep"  align-center :active="active" finish-status="success">
            <el-step title="基本信息"></el-step>
            <el-step title="本市住房信息"></el-step>
            <el-step title="添加附件"></el-step>
            <el-step title="完成"></el-step>
        </el-steps>        
        <div class="apply-part" style="margin-top:20px">
            <div class="apply-part-title">
                <div class="blue-sign"></div>
                <span>单位信息</span>
            </div>
            <el-form
                style="margin-left:100px;padding:35px 0 14px 0;width::calc(100% -100px)"
                label-width="160px"
                size="small"
                :rules="rules"
                :model="applyInfo.rentCompanyEntity"
                ref="applyInfo3"
                :disabled="disabled || applyInfo.rentIntentEntity.applyType == 0"
            >
                <el-row class="applyType" v-if="applyInfo.rentIntentEntity.applyType != 0">
                    <el-radio-group v-model="applyInfo.rentIntentEntity.applyType" @change="applyTypeChange">
                        <el-radio :label="1">个人申请</el-radio>
                        <el-radio :label="2">单位员工</el-radio>
                    </el-radio-group>
                </el-row>                
                <div v-if="isCustomize">
                    <el-row class="compantip">
                        <el-col>
                            <el-form-item label="单位全称" prop="companyName">
                                <el-select v-model="applyInfo.rentCompanyEntity.companyName"  filterable   placeholder="请选择"  @change="companyChange" >  <!---->
                                    <el-option
                                        v-for="item in companyList"
                                        :key="item.id"
                                        :label="item.companyName"
                                        :value="item.companyName">
                                    </el-option>
                                </el-select>
                                <el-button type="primary" style="margin-left:10px" @click="changeCustomize" v-if="applyInfo.rentIntentEntity.applyType===1">切换输入单位</el-button>
                                <span style="font-size:14px;color:#BBBBBB;margin-left:15px">单位下拉框支持手输匹配</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="keyEnterprises" v-if="isKeyEnterprises && applyInfo.rentIntentEntity.applyType!='1' && applyInfo.rentCompanyEntity.companyName">
                        <el-col>
                            <span style="font-size:14px;color:red;">此单位是重点单位</span>
                        </el-col>
                    </el-row>
                    <el-row class="applyType" v-if="applyInfo.rentIntentEntity.applyType!='1'">
                        <el-col>
                            <span style="font-size:14px;color:#BBBBBB;">注：列表找不到？确认所在单位是否已申请单位资格</span>
                        </el-col>
                    </el-row>
                    <el-row class="applyType" v-else>
                        <el-col>
                            <span style="font-size:14px;color:#BBBBBB;">注：列表找不到？点击上方【切换输入单位】按钮可手工填写单位信息</span>
                        </el-col>
                    </el-row>
                </div>
                <div v-else>
                    <el-row class="compantip">
                        <el-col >
                            <el-form-item label="单位全称" prop="companyName">
                                <el-input v-model="applyInfo.rentCompanyEntity.companyName"></el-input>
                                <el-button type="primary" style="margin-left:10px" @click="changeCustomize" v-if="applyInfo.rentIntentEntity.applyType===1">切换选择单位</el-button>
                                <span style="font-size:14px;color:#BBBBBB;margin-left:15px">请填写正确的单位名称，有括号的请注意大小写</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="compantip">
                        <el-col >
                            <el-form-item  label="统一信用代码" prop="companyCode">
                                <el-input maxlength="18" v-model="applyInfo.rentCompanyEntity.companyCode"></el-input>
                                <span style="font-size:14px;color:#BBBBBB;margin-left:15px">请填写18位社会信用代码</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="compantip">
                        <el-col >
                            <el-form-item prop="companyAddress" label="单位地址"><el-input  v-model="applyInfo.rentCompanyEntity.companyAddress"></el-input></el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="compantip">
                        <el-col >
                            <el-form-item prop="registeredRegion" label="单位注册所在区">
                                <!-- <el-input  v-model="applyInfo.rentCompanyEntity.registeredRegion"></el-input> -->
                                <el-select v-model="applyInfo.rentCompanyEntity.registeredRegion"  placeholder="请选择">
                                    <el-option
                                        v-for="item in regionList"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="compantip">
                        <el-col >
                            <el-form-item label="邮编"><el-input maxlength="6" v-model="applyInfo.rentCompanyEntity.companyZip"></el-input></el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="compantip">
                        <el-col >
                            <el-form-item label="电话"><el-input v-model="applyInfo.rentCompanyEntity.companyPhone"></el-input></el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </div> 
        <div class="apply-part" style="margin-bottom:20px">
            <div class="apply-part-title">
                <div class="blue-sign"></div>
                <span>意向户型</span>
            </div>
            <el-form
                style="margin-left:100px;padding:35px 0 14px 0;width:calc(100% -100px)"
                label-width="160px"
                size="small"
                :rules="rules"
                :model="applyInfo.rentIntentEntity"
                ref="applyInfo1"
                :disabled="intentDisabled"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item  label="租赁方式" prop="rentType">
                            <el-select @change="ChangeRentType" v-model="applyInfo.rentIntentEntity.rentType">
                                <el-option
                                    v-for="item in rentwayList"
                                    :key="item.enumValue"
                                    :label="item.enumText"
                                    :value="item.enumValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item  label="街道" prop="streetTown">
                            <el-select @change="ChangeStreetTown" v-model="applyInfo.rentIntentEntity.streetTown">
                                <el-option
                                    v-for="item in streettownlist"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item  label="小区" prop="communityID">
                            <el-select no-data-text="请选择街道" @change="ChangeCommunity" v-model="applyInfo.rentIntentEntity.communityID">
                                <el-option
                                    v-for="item in communitylist"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item  label="户型" prop="roomKindID">
                            <el-select no-data-text="请选择小区和租赁方式" v-model="applyInfo.rentIntentEntity.roomKindID">
                                <el-option
                                    v-for="item in roomlist"
                                    :key="item.kindID"
                                    :label="item.kindName"
                                    :value="item.kindID">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item  label="居住偏好">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 10}"
                                maxlength="400"
                                v-model="applyInfo.rentIntentEntity.preferences">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="apply-part">
            <div class="apply-part-title">
                <div class="blue-sign"></div>
                <span>主申请人</span>
            </div>
            <el-form
                style="margin-left:100px;padding:35px 0 14px 0;width::calc(100% -100px)"
                label-width="160px"
                size="small"
                :rules="rules"
                :model="apply2"
                ref="apply2"
                :disabled="disabled"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item class="appinput" label="姓名" prop="name">
                            <el-input disabled v-model="apply2.name" style="width:60%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="性别" prop="sex">
                            <el-select v-model="apply2.sex" style="width:60%" disabled>
                                <el-option
                                v-for="item in sexlist"
                                :key="item.enumValue"
                                :label="item.enumText"
                                :value="item.enumValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item class="appinput" label="证件号码">
                            <el-input disabled v-model="apply2.certNo" style="width:60%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="出生年月" prop="birthday">
                            <el-date-picker  style="width:60%" disabled
                                class="picker"
                                v-model="apply2.birthday"
                                type="date"
                                :default-value="new Date(1990,0,1)">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="mobile" class="appinput" label="手机" >
                            <el-input disabled v-model="apply2.mobile" style="width:60%"></el-input>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="12">
                        <el-form-item label="政治面貌" prop="politicalStatus">
                            <el-select v-model="apply2.politicalStatus" style="width:60%">
                                <el-option
                                v-for="item in policylist"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col >
                        <el-form-item label="婚姻状况" prop="maritalStatus">
                            <el-select v-model="apply2.maritalStatus" style="width:25%">
                                <el-option
                                v-for="item in marriagelist"
                                :key="item.enumValue"
                                :label="item.enumText"
                                :value="item.enumValue">
                                </el-option>
                            </el-select>
                            <span v-if="apply2.maritalStatus === 1" style="font-size:14px;color:#FF0000;">&nbsp;&nbsp;已婚的，配偶及未婚子女，必须要登记在家庭成员信息里</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="email" class="appinput" label="Email">
                            <el-input v-model="apply2.email" style="width:60%"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item  class="appinput" label="固定电话">
                            <el-input maxlength="20" v-model="apply2.telephone" style="width:60%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="职称" prop="title">
                            <el-select v-model="apply2.title" style="width:60%">
                                <el-option
                                v-for="item in titlelist"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="学历" prop="education">
                            <el-select v-model="apply2.education" style="width:60%">
                                <el-option
                                v-for="item in educationlist"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="职业" prop="profession">
                            <el-select v-model="apply2.profession" style="width:60%">
                                <el-option
                                v-for="item in positionlist"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="户口性质" prop="identityType">
                            <el-select v-model="apply2.identityType" style="width:60%">
                                <el-option
                                v-for="item in identitytypelist"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="民族" prop="nation">
                            <el-select v-model="apply2.nation" filterable style="width:60%">
                                <el-option
                                v-for="item in nationlist"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col v-if="apply2.identityType == '02'">
                        <el-form-item label="是否有居住证" prop="isResidenceCard">
                            <el-radio v-model="apply2.isResidenceCard" :label="true">是</el-radio>
                            <el-radio v-model="apply2.isResidenceCard" :label="false">否</el-radio>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <el-row>
                    <el-col v-if="apply2.identityType == '02'">
                        <el-form-item label="是否持证满两年" prop="isLiveTwoYears">
                            <el-radio v-model="apply2.isLiveTwoYears" :label="true">是</el-radio>
                            <el-radio v-model="apply2.isLiveTwoYears" :label="false">否</el-radio>
                            <span style="font-size:14px;color:#BBBBBB;">即：非本市户口，持上海市居住证不满二年的不能申请</span>
                        </el-form-item>
                    </el-col>
                </el-row> -->
                <el-row >
                    <el-col >
                        <el-form-item label="是否在本单位缴社保" prop="isSocialSecurity">
                            <el-radio v-model="apply2.isSocialSecurity" :label="true">是</el-radio>
                            <el-radio v-model="apply2.isSocialSecurity" :label="false">否</el-radio>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <el-row>
                    <el-col >
                        <el-form-item label="是否连续纳缴社保金" prop="isSocialSecurityGold12Month">
                            <el-radio v-model="apply2.isSocialSecurityGold12Month" :label="true">是</el-radio>
                            <el-radio v-model="apply2.isSocialSecurityGold12Month" :label="false">否</el-radio>                            
                            <span style="font-size:14px;color:#BBBBBB;">即：申请日期前12个月是否有连续缴纳社保金</span>
                        </el-form-item>
                    </el-col>
                </el-row> -->
                <!-- <el-row v-if="applyInfo.rentIntentEntity.applyType!=1"> -->
                <el-row v-if="false">
                    <el-col >
                        <el-form-item label="是否申请人才公寓" prop="isApplyTalent">
                            <el-radio v-model="applyInfo.rentIntentEntity.isApplyTalent" :label="true">是</el-radio>
                            <el-radio v-model="applyInfo.rentIntentEntity.isApplyTalent" :label="false">否</el-radio>
                            <span v-if="applyInfo.rentIntentEntity.isApplyTalent" style="font-size:14px;color:#FF0000;">申请人才必须同时具备：1.社保；2.本市户籍或居住证；3.本科及以上学历或中级及以上职称(需职称相关的聘书)</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="liveAddress" label="完整的户籍地址">
                            <el-input maxlength="50" v-model="apply2.liveAddress" style="width:78%"></el-input>
                            <span style="font-size:14px;color:#FF0000;">具体到几号</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item class="appinput"  label="户籍邮编">
                            <el-input maxlength="6" v-model="apply2.liveZip" style="width:60%"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item prop="currentAddress"  label="完整的居住(通讯)地址">
                            <el-input maxlength="50" v-model="apply2.currentAddress" style="width:78%"></el-input>
                            <span style="font-size:14px;color:#FF0000;">具体到几号</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item class="appinput" label="居住地邮编">
                            <el-input maxlength="6" v-model="apply2.currentZip" style="width:60%"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item prop="isOtherAreaApply"  label="上海其它区公租房">
                            <el-radio v-model="isOtherAreaApply" :label="true">我有申请居住过</el-radio>
                            <el-radio v-model="isOtherAreaApply" :label="false">从来没申请过</el-radio>

                            <span><el-button type="primary" v-if="isOtherAreaApply" size="small" @click="addOtherArea">维护居住记录</el-button></span>
                            <span style="font-size:14px;color:#BBBBBB; margin-left:10px;">即：上海除嘉定区以外的其它区</span>
                        </el-form-item>                        
                    </el-col>
                </el-row>
            </el-form>            
        </div>

        <div class="apply-part">
            <div class="apply-part-title">
                <div class="blue-sign"></div>
                <span>家庭成员</span>
            </div>
            <div>
                <el-form size="small" style="margin-left:100px;padding:35px 0 14px 0;width::calc(100% -100px)" :disabled="disabled">
                    <el-form-item >                        
                        <div style="display:flex">
                            <div style="margin-right:10px;">
                                <el-button type="primary" @click="showaddFamily">+添加家庭成员</el-button>
                            </div>
                            <div class="relationunit" v-for="(item,index) in applyInfo.renterFamliyList" :key="index" >
                                <img @click="onDelete(index,item.id)" v-if="!disabled" src="../../assets/imgs/close_blue.png"  class="blueclose">
                                <div @click="editFamily(index)"><span>{{item.name}}({{relationlist[item.re] != undefined ? relationlist[item.re].enumText : ""}})</span></div>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="add-family" v-if="addFamily">
                <div style="width:100%;text-align:right">
                    <img style="cursor: pointer;" src="../../assets/imgs/close_1.png" @click="closeaddFamily">
                </div>
                <el-form
                    style="margin-left:100px;padding:35px 0 14px 0;width::calc(100% -100px)"
                    label-width="135px"
                    size="small"
                    :rules="rules"
                    :model="addfamily"
                    ref="addfamily"
                    :disabled="disabled"
                    v-if="addstep"
                >
                <el-row>
                        <el-col :span="12">
                            <el-form-item prop="name" class="appinput" label="姓名">
                                <el-input v-model="addfamily.name" style="width:60%"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="性别" prop="sex">
                                <el-select v-model="addfamily.sex" style="width:60%">
                                    <el-option
                                    v-for="item in sexlist"
                                    :key="item.enumValue"
                                    :label="item.enumText"
                                    :value="item.enumValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="证件类型" prop="certType">
                                <el-select v-model="addfamily.certType" style="width:60%">
                                    <el-option
                                    v-for="item in certType"
                                    :key="item.enumValue"
                                    :label="item.enumText"
                                    :value="item.enumValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="certNo" class="appinput" label="证件号码">
                                <el-input maxlength="18" v-model="addfamily.certNo" @blur="discernCertNo" style="width:60%"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="出生年月" prop="birthday">
                                <el-date-picker style="width:60%"
                                    class="picker"
                                    v-model="addfamily.birthday"
                                    type="date"
                                    :default-value="new Date(1990,0,1)">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="婚姻状况" prop="maritalStatus">
                                <el-select v-model="addfamily.maritalStatus" style="width:60%">
                                    <el-option
                                    v-for="item in marriagelist"
                                    :key="item.enumValue"
                                    :label="item.enumText"
                                    :value="item.enumValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item class="appinput" label="手机" >
                                <el-input maxlength="11" v-model="addfamily.mobile" style="width:60%"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item class="appinput" label="固定电话">
                                <el-input maxlength="20" v-model="addfamily.telephone" style="width:60%"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="户口性质" prop="identityType">
                                <el-select v-model="addfamily.identityType" style="width:60%" >
                                    <el-option
                                    v-for="item in identitytypelist"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="政治面貌" prop="politicalStatus">
                                <el-select v-model="addfamily.politicalStatus" style="width:60%">
                                    <el-option
                                    v-for="item in policylist"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="与申请人关系"  prop="relationPrincipal">
                                <el-select v-model="addfamily.relationPrincipal" style="width:60%">
                                    <el-option
                                    v-for="item in relationlist"
                                    :key="item.enumValue"
                                    :label="item.enumText"
                                    :value="item.enumValue">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="是否同住" prop="isChummage">
                                <el-radio v-model="addfamily.isChummage" :label="true">是</el-radio>
                                <el-radio v-model="addfamily.isChummage" :label="false">否</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- <el-row>
                        <el-col >
                            <el-form-item label="持证是否满两年" prop="isLiveTwoYears">
                                <el-radio v-model="addfamily.isLiveTwoYears" :label="true">是</el-radio>
                                <el-radio v-model="addfamily.isLiveTwoYears" :label="false">否</el-radio>
                                <span style="font-size:14px;color:#BBBBBB;">持上海市居民身份证不满二年不能申请</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col >
                            <el-form-item label="是否持连2缴社保金" prop="">
                                <el-radio v-model="addfamily.isSocialSecurityGold12Month" :label="true">是</el-radio>
                                <el-radio v-model="addfamily.isSocialSecurityGold12Month" :label="false">否</el-radio>
                                <span style="font-size:14px;color:#BBBBBB;">申请日期前12个月若没有连续缴纳社保金将不能申请</span>
                            </el-form-item>
                        </el-col>
                    </el-row> -->
                  
                    <el-row>
                        <el-col :span="16">
                            <el-form-item prop="liveAddress" label="户籍地址">
                                <el-input maxlength="100" v-model="addfamily.liveAddress" style="width:100%"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item  label="上传附件" prop="attachment">
                                <div>
                                    <p style="font-size:14px;color:#BBBBBB;">图片大小建议在2M以内</p>
                                    <div>
                                        <p style="color:#333333">1、免冠证件照</p>
                                        <p style="color:#999999">请确保头像正面朝上！须上传图片格式</p>
                                    </div>
                                    <div style="display:flex;align-items:center;margin-top:23px">                                        
                                        <MultiUploader ref="uploader1" :disabled = disabled></MultiUploader>                                        
                                    </div>
                                    <div>
                                        <p style="color:#333333">2、相关证件扫描件</p>
                                        <p style="color:#999999">未满18周岁：上传出生证和户口本原件页；已满18周岁：上传身份证原件正反面和户口本原件页</p>
                                    </div>
                                    <div style="display:flex;align-items:center;margin-top:23px">
                                        <MultiUploader ref="uploader2" :disabled = disabled></MultiUploader>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="18" >
                            <el-form-item style="text-align:center;">
                                <el-button type="success" size="small" @click="onNext()" :loading="nextLoading" v-if="!disabled">下一步</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-form
                    style="margin-left:100px;padding:35px 0 14px 0;width::calc(100% -100px)"
                    label-width="165px"
                    size="small"
                    :model="famliyroominfo"
                    ref="famliyroominfo"
                    :disabled="disabled"
                    v-if="!addstep  || disabled"
                >

                    <div class="apply-part" style="margin-bottom:30px">
                        <div class="apply-part-title">
                            <div class="blue-sign"></div>
                            <span>本市户籍地住房</span>
                        </div>
                        <el-form
                            style="padding:35px 0 14px 0;"
                            label-width="165px"
                            size="small"
                            :rules="rules"
                            :model="famliyroominfo.beCityEntity"
                            :disabled="disabled"
                        >
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="是否有本地户籍住房" prop="beCity">
                                        <el-radio v-model="famliyroominfo.beCityEntity.beCity" :label="0">是</el-radio>
                                        <el-radio v-model="famliyroominfo.beCityEntity.beCity" :label="1">否</el-radio>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div v-if="!famliyroominfo.beCityEntity.beCity">
                            <el-form :inline="true"
                                style="padding:0 0 14px 0;"
                                label-width="165px"
                                size="small"
                                :rules="rules"
                                :model="famliyroominfo.beCityEntity"
                                ref="cityinfo1"
                                :disabled="disabled"
                            >
                            <el-form-item prop="cityAdress" class="houseaddress" label="房屋坐落地址">
                                <el-input v-model="famliyroominfo.beCityEntity.cityAdress"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-select v-model="famliyroominfo.beCityEntity.cityAreaType">
                                    <el-option
                                    v-for="item in areatype"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="cityArea">
                                <el-input v-model="famliyroominfo.beCityEntity.cityArea" maxlength="8"></el-input>
                            </el-form-item>
                            <el-form-item ><span class="rightstar">平方米</span> </el-form-item>
                        </el-form>
                        <el-form
                            style="padding:0 0 14px 0;"
                            label-width="165px"
                            size="small"
                            :rules="rules"
                            ref="cityinfo2"
                            :model="famliyroominfo.beCityEntity"
                            :disabled="disabled"
                        >
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item prop="cityPropertyOwner" class="appinput1" label="产权人或公房承租人">
                                        <el-input v-model="famliyroominfo.beCityEntity.cityPropertyOwner" style="width:68%"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item class="appinput1" label="该住房户籍人口总数" prop="cityPopulation">
                                        <el-input v-model="famliyroominfo.beCityEntity.cityPopulation" maxlength="3" style="width:68%"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="产权性质" prop="cityPropertyType">
                                        <el-select v-model="famliyroominfo.beCityEntity.cityPropertyType" style="width:68%">
                                            <el-option
                                            v-for="item in propertytypelist"
                                            :key="item.enumValue"
                                            :label="item.enumText"
                                            :value="item.enumValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="房屋类型" prop="cityRoomType">
                                        <el-select v-model="famliyroominfo.beCityEntity.cityRoomType" style="width:68%">
                                            <el-option
                                            v-for="item in housetypelist"
                                            :key="item.enumValue"
                                            :label="item.enumText"
                                            :value="item.enumValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="21" class="addhouseremark">
                                    <el-form-item  label="备注">
                                        <el-input
                                            type="textarea"
                                            :autosize="{ minRows: 4, maxRows: 10}"
                                            v-model="famliyroominfo.beCityEntity.cityRemark">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        </div>
                    </div>

                    <div class="apply-part" style="margin-bottom:30px">
                        <div class="apply-part-title">
                            <div class="blue-sign"></div>
                            <span>本区产权住房情况</span>
                        </div>
                        <el-form
                            style="padding:35px 0 14px 0;"
                            label-width="165px"
                            size="small"
                            :rules="rules"
                            :model="famliyroominfo.beRegionEntity"
                            :disabled="disabled"
                        >
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="是否有本区住房" prop="beRegion">
                                        <el-radio v-model="famliyroominfo.beRegionEntity.beRegion" :label="0">是</el-radio>
                                        <el-radio v-model="famliyroominfo.beRegionEntity.beRegion" :label="1">否</el-radio>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div v-if="!famliyroominfo.beRegionEntity.beRegion">
                        <el-form :inline="true"
                            style="padding:0 0 14px 0;"
                            label-width="145px"
                            size="small"
                            :rules="rules"
                            ref="regioninfo1"
                            :model="famliyroominfo.beRegionEntity"
                            :disabled="disabled"
                        >
                            <el-form-item prop="regionAdress" class="houseaddress" label="房屋坐落地址"><el-input v-model="famliyroominfo.beRegionEntity.regionAdress"></el-input></el-form-item>
                            <el-form-item>
                                <el-select v-model="famliyroominfo.beCityEntity.regionAreaType">
                                    <el-option
                                    v-for="item in areatype"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="regionArea"><el-input v-model="famliyroominfo.beRegionEntity.regionArea" maxlength="8"></el-input></el-form-item>
                            <el-form-item ><span class="rightstar">平方米</span></el-form-item>
                        </el-form>
                        <el-form
                            style="padding:0 0 14px 0;"
                            label-width="150px"
                            size="small"
                            :rules="rules"
                            ref="regioninfo2"
                            :model="famliyroominfo.beRegionEntity"
                            :disabled="disabled"
                        >
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item prop="regionPropertyOwner" class="appinput1" label="产权人或公房承租人">
                                        <el-input v-model="famliyroominfo.beRegionEntity.regionPropertyOwner" style="width:68%"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item class="appinput1" label="该住房户籍人口总数" prop="regionPopulation">
                                        <el-input v-model="famliyroominfo.beRegionEntity.regionPopulation" maxlength="3" style="width:68%"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="产权性质" prop="regionPropertyType">
                                        <el-select v-model="famliyroominfo.beRegionEntity.regionPropertyType" style="width:68%">
                                            <el-option
                                            v-for="item in propertytypelist"
                                            :key="item.enumValue"
                                            :label="item.enumText"
                                            :value="item.enumValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="房屋类型" prop="regionRoomType">
                                        <el-select v-model="famliyroominfo.beRegionEntity.regionRoomType" style="width:68%">
                                            <el-option
                                            v-for="item in housetypelist"
                                            :key="item.enumValue"
                                            :label="item.enumText"
                                            :value="item.enumValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="21" class="addhouseremark">
                                    <el-form-item  label="备注">
                                        <el-input
                                            type="textarea"
                                            :autosize="{ minRows: 4, maxRows: 10}"
                                            v-model="famliyroominfo.beRegionEntity.regionRemark">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        </div>
                    </div>

                    <div class="apply-part" style="margin-bottom:30px">
                        <div class="apply-part-title">
                            <div class="blue-sign"></div>
                            <span>承租本区公有住房情况</span>
                        </div>
                        <el-form
                            style="padding:35px 0 14px 0;"
                            label-width="165px"
                            size="small"
                            :rules="rules"
                            :model="famliyroominfo.bePublicEntity"
                            :disabled="disabled"
                        >
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="是否有本区住房" prop="bePublic">
                                        <el-radio v-model="famliyroominfo.bePublicEntity.bePublic" :label="0">是</el-radio>
                                        <el-radio v-model="famliyroominfo.bePublicEntity.bePublic" :label="1">否</el-radio>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div v-if="!famliyroominfo.bePublicEntity.bePublic">
                        <el-form :inline="true"
                            style="padding:0 0 14px 0;"
                            label-width="165px"
                            size="small"
                            :rules="rules"
                            ref="publicinfo1"
                            :model="famliyroominfo.bePublicEntity"
                            :disabled="disabled"
                        >
                            <el-form-item prop="publicAdress" class="houseaddress" label="房屋坐落地址"><el-input v-model="famliyroominfo.bePublicEntity.publicAdress"></el-input></el-form-item>
                            <el-form-item>
                                <el-select v-model="famliyroominfo.beCityEntity.publicAreaType">
                                    <el-option
                                    v-for="item in areatype"
                                    :key="item.name"
                                    :label="item.name"
                                    :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="publicArea"><el-input v-model="famliyroominfo.bePublicEntity.publicArea" maxlength="8"></el-input></el-form-item>
                            <el-form-item ><span class="rightstar">平方米</span></el-form-item>
                        </el-form>
                        <el-form
                            style="padding:0 0 14px 0;"
                            label-width="150px"
                            size="small"
                            :rules="rules"
                            ref="publicinfo2"
                            :model="famliyroominfo.bePublicEntity"
                            :disabled="disabled"
                        >
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item prop="publicPropertyOwner" class="appinput1" label="产权人或公房承租人">
                                        <el-input v-model="famliyroominfo.bePublicEntity.publicPropertyOwner" style="width:68%"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item class="appinput1" label="该住房户籍人口总数" prop="publicPopulation">
                                        <el-input v-model="famliyroominfo.bePublicEntity.publicPopulation" maxlength="3" style="width:68%"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="产权性质" prop="publicPropertyType">
                                        <el-select v-model="famliyroominfo.bePublicEntity.publicPropertyType" style="width:68%">
                                            <el-option
                                            v-for="item in propertytypelist"
                                            :key="item.enumValue"
                                            :label="item.enumText"
                                            :value="item.enumValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="房屋类型" prop="publicRoomType">
                                        <el-select v-model="famliyroominfo.bePublicEntity.publicRoomType" style="width:68%">
                                            <el-option
                                            v-for="item in housetypelist"
                                            :key="item.enumValue"
                                            :label="item.enumText"
                                            :value="item.enumValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="21" class="addhouseremark">
                                    <el-form-item  label="备注">
                                        <el-input
                                            type="textarea"
                                            :autosize="{ minRows: 4, maxRows: 10}"
                                            v-model="famliyroominfo.bePublicEntity.publicRemark">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        </div>
                    </div>

                    <div class="apply-part" style="margin-bottom:30px">
                        <div class="apply-part-title">
                            <div class="blue-sign"></div>
                            <span>动迁安置补偿</span>
                        </div>
                        <el-form
                            style="padding:35px 0 14px 0;"
                            label-width="165px"
                            size="small"
                            :rules="rules"
                            ref="haveCompensation"
                            :model="famliyroominfo.haveCompensationEntity"
                            :disabled="disabled"
                        >
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="是否享受动迁安置补贴" prop="haveCompensation">
                                        <el-radio v-model="famliyroominfo.haveCompensationEntity.haveCompensation" :label="true">是</el-radio>
                                        <el-radio v-model="famliyroominfo.haveCompensationEntity.haveCompensation" :label="false">否</el-radio>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div v-if="famliyroominfo.haveCompensationEntity.haveCompensation">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item prop="compensationArea" class="rightlabel" label="补偿面积">
                                        <div style="display:flex">
                                            <el-input v-model="famliyroominfo.haveCompensationEntity.compensationArea" maxlength="8"></el-input>
                                            <span style="margin-left:10px">平方米</span>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item prop="placementDate" label="动迁安置时间">
                                        <el-date-picker
                                            class="picker"
                                            v-model="famliyroominfo.haveCompensationEntity.placementDate"
                                            type="date"
                                            :default-value="new Date(1990,0,1)">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item prop="areaTotal" class="rightlabel" label="合计建筑面积">
                                        <div style="display:flex">
                                            <el-input v-model="famliyroominfo.haveCompensationEntity.areaTotal" maxlength="8"></el-input>
                                            <span style="margin-left:10px">平方米</span>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item prop="compensationMoney" class="rightlabel" label="补偿金额">
                                        <div style="display:flex">
                                            <el-input v-model="famliyroominfo.haveCompensationEntity.compensationMoney" maxlength="8"></el-input>
                                            <span style="margin-left:10px">元</span>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item class="rightlabel" label="人均建筑面积" prop="areaAvg">
                                        <div style="display:flex">
                                            <el-input v-model="famliyroominfo.haveCompensationEntity.areaAvg" maxlength="8"></el-input>
                                            <span style="margin-left:10px">平方米</span>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item prop="populationTotal" class="rightlabel" label="核定面积家庭总人数">
                                        <div style="display:flex">
                                            <el-input v-model="famliyroominfo.haveCompensationEntity.populationTotal" maxlength="3"></el-input>
                                            <span style="margin-left:10px">人</span>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            </div>
                        </el-form>
                    </div>
                </el-form>
                <div style="padding-bottom: 50px;text-align:center" v-if="!addstep">
                    <el-button type="success" size="small" @click="onPrevious">上一步</el-button>
                    <el-button type="primary" size="small" v-if="!disabled" @click="onSave">保存</el-button>
                </div>
            </div>
        </div>

        <el-divider class="bottomdivider"></el-divider>
        <div style="text-align:center">
            <el-button  type="primary" @click="onNextCheck()" :loading="nextLoading">下一步</el-button>
        </div>

        <!--添加居住记录-->
        <el-dialog id="invoice-title"
          title="添加居住记录"
          :visible.sync="showAreaDialog"
          width="30%"
          height="50%"
          :center="false"
          top="20vh"
          :close-on-click-modal="false"
          :lock-scroll="true"
        >
            <el-row>
                <el-col :span="24">
                    <div style="color:red;padding-bottom:10px;">先选择居住区，再填写入住期数（月）</div>
                </el-col>
            </el-row>
            <div style="height:220px; overflow-y:scroll">
                <el-row v-for="(item,index) in areaList" :key="index" style="margin-bottom:5px;">
                    <el-col :span="12">
                        <el-checkbox v-model="item.checked">
                            {{item.areaName}}
                        </el-checkbox>
                    </el-col>
                    <el-col :span="12" align="left">
                        <el-input size="small" :disabled="!item.checked" maxlength="2" v-model="item.months" oninput ="value=value.replace(/[^0-9]/g,'')" style="width:100px;"></el-input> 个月
                    </el-col>
                </el-row>
            </div>
            <div>
                <el-button type="primary" style="width: 100%" 
                    @click="confirmAdd()">
                    确 定
                </el-button>
            </div>
      </el-dialog>
    </div>
</template>

<script>
import PublicApi from "@/api/public/index";
import PortalApi from "@/api/portal/index";
import UserApi from "@/api/user/index";
import { getUserInfo } from "@/store/index";
let moment = require("moment")
import { isEmail, isMobile,isIdCardNo,areaReg,isPositiveInt,isInt } from "@/helper/validate";
import MultiUploader from '../../components/upload/MultiUploader.vue';
export default {
    data(){
        return{
            isKeyEnterprises:false,
            nextLoading:false,
            isCustomize:true,
            addFamily:false,
            addstep:true,
            applyInfo:{
                rentBasicEntity:{
                    id:'',
                    name:'',
                    sex:'',
                    birthday:'',
                    maritalStatus:'',
                    certNo:'',
                    nation:'',
                    politicalStatus:'',
                    telephone:'',
                    mobile:'',
                    email:'',
                    liveAddress:'',
                    liveZip:'',
                    currentAddress:'',
                    currentZip:'',
                    
                },
                rentQualificationsEntity:{
                    education:'',
                    title:'',
                    identityType:'',
                    position:'',
                    isLiveTwoYears:null,
                    isSocialSecurityGold12Month:null,
                    isResidenceCard:null,
                    isSocialSecurity:null
                },
                rentIntentEntity:{
                    applyType: 1,
                    communityID:'',
                    rentType: null,
                    roomKindID: '',
                    streetTown: '',
                    preferences:'',
                    isApplyTalent:false
                },
                rentCompanyEntity:{
                    companyID:'',
                    companyName:'',
                    companyCode:'',
                    companyAddress:'',
                    companyZip:'',
                    companyPhone:'',
                    companyType:'',
                    licenseNo:'',
                    taxRegisterNo:'',
                    registeredRegion:'',
                    isCustomize:true
                },
                renterFamliyList:[],
            },
            apply2:{
                name:'',
                sex:'',
                birthday:'',
                maritalStatus:'',
                certNo:'',
                nation:'',
                politicalStatus:'',
                telephone:'',
                mobile:'',
                email:'',
                liveAddress:'',
                liveZip:'',
                currentAddress:'',
                currentZip:'',

                education:'',
                title:'',
                identityType:'',
                position:'',
                isResidenceCard:null,
                isSocialSecurity:null,
                isLiveTwoYears:null,
                isSocialSecurityGold12Month:null,
                profession:'',
                otherRegionApplyInfo:""
            },
            apply22:{},
            addfamily:{
                id:'',
                name:'',
                sex:'',
                certNo:'',
                birthday:'',
                maritalStatus:'',
                relationPrincipal:'',
                politicalStatus:'',
                telephone:'',
                mobile:'',
                isSocialSecurityGold12Month:false,
                isLiveTwoYears:false,
                identityType:'',
                liveAddress:'',
                email:'',
                isChummage:true,
                gravatarPhoto:'',
                gravatarPhotos:[],
                identityPhoto:'',
                identityPhotos:[],
            },
            famliyroominfo:{
                beCityEntity:{
                    beCity: 1,
                    cityAdress: null,
                    cityArea: null,
                    cityPopulation: null,
                    cityPropertyOwner: null,
                    cityPropertyType: null,
                    cityRemark: null,
                    cityRoomType: null,
                    cityAreaType:null
                },
                beRegionEntity:{
                    beRegion: 1,
                    regionAdress: null,
                    regionArea: null,
                    regionPopulation: null,
                    regionPropertyOwner: null,
                    regionPropertyType: null,
                    regionRemark: null,
                    regionRoomType: null,
                    regionAreaType:null
                },
                bePublicEntity:{
                    bePublic: 1,
                    publicAdress: null,
                    publicArea: null,
                    publicPopulation: null,
                    publicPropertyOwner: null,
                    publicPropertyType: null,
                    publicRemark: null,
                    publicRoomType: null,
                    publicAreaType:null
                },
                haveCompensationEntity:{
                    areaAvg: null,
                    areaTotal: null,
                    compensationArea: null,
                    compensationMoney: null,
                    haveCompensation: false,
                    placementDate: null,
                    populationTotal: null,
                },
                familyApplyID: "",
                familyCertNo: "",
                familyName: "",
            },
            type:'',
            propertytypelist:[],
            housetypelist:[],
            areatype:[{
                name:'建筑面积',code:0
            },{
                name:'居住面积',code:1
            }],

            addfamilys:[],
            famliyroominfos:[],
            fileList: [],
            rentwayList:[],
            streettownlist:[],
            communitylist:[],
            roomlist:[],
            sexlist:[],
            certType:[],
            marriagelist:[],
            policylist:[],
            titlelist:[],
            educationlist:[],
            positionlist:[],
            identitytypelist:[],
            nationlist:[],
            relationlist:[],
            regionList:[],

            userInfo:{},

            active:0,
            id:'',
            disabled:false,
            intentDisabled:false, // 续租的，不让改意向房型

            // 其它区入住情况
            isOtherAreaApply:"",
            otherAreaApply:"",
            showAreaDialog:false,
            areaList:[],

            addfamilyflag:-1,
            familyID:'',

            iscity:false,
            isregion:false,
            ispublic:false,
            iscompensation:false,

            // 表单验证，需要在 el-form-item 元素中增加 prop 属性
            rules: {
                rentType: [{
                    required: true,
                    message: "租赁方式不可为空",
                    trigger: "change"
                }],
                streetTown: [{
                    required: true,
                    message: "街道不可为空",
                    trigger: "change"
                }],
                communityID: [{
                    required: true,
                    message: "小区不可为空",
                    trigger: "change"
                },],
                roomKindID: [{
                    required: true,
                    message: "户型不可为空",
                    trigger: "change"
                },],
                name: [{
                    required: true,
                    message: "姓名不可为空",
                    trigger: "blur"
                },],
                sex: [{
                    required: true,
                    message: "性别不可为空",
                    trigger: "change"
                },],
                certType: [{
                    required: true,
                    message: "证件类型不可为空",
                    trigger: "change"
                },],
                maritalStatus: [{
                    required: true,
                    message: "婚姻状况不可为空",
                    trigger: "change"
                },],
                birthday: [{
                    required: true,
                    message: "出生年月不可为空",
                    trigger: "blur"
                },],
                certNo: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("请输入证件号码！"));
                        } else if (!isIdCardNo(value) && this.addfamily.certType == 0) {
                            callback(new Error("身份证号码格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                politicalStatus: [{
                    required: true,
                    message: "政治面貌不可为空",
                    trigger: "change"
                },],
                mobile: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("请输入手机号码！"));
                        } else if (!isMobile(value)) {
                            callback(new Error("手机号码格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                email: [{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("请输入邮箱！"));
                        } else if (!isEmail(value)) {
                            callback(new Error("邮箱格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                title: [{
                    required: true,
                    message: "职称不可为空",
                    trigger: "blur"
                },],
                education: [{
                    required: true,
                    message: "学历不可为空",
                    trigger: "blur"
                },],
                position: [{
                    required: true,
                    message: "职业不可为空",
                    trigger: "blur"
                },],
                profession: [{
                    required: true,
                    message: "职业不可为空",
                    trigger: "blur"
                },],
                identityType: [{
                    required: true,
                    message: "户口性质不可为空",
                    trigger: "blur"
                },],
                nation: [{
                    required: true,
                    message: "民族不可为空",
                    trigger: "blur"
                },],
                // isLiveTwoYears: [{
                //     required: true,
                //     message: "是否持证满两年不可为空",
                // },],
                // isSocialSecurityGold12Month: [{
                //     required: true,
                //     message: "是否连缴社保金不可为空",
                // },],
                isResidenceCard: [{
                    message: "是否有居住证不可为空",
                    required: true,
                },],
                isSocialSecurity: [{
                    message: "是否缴纳社保不可为空",
                    required: true,
                },],
                isChummage: [{
                    required: true,
                },],
                relationPrincipal: [{
                    required: true,
                    message: "与申请人关系不可为空",
                    trigger: "change"
                },],
                liveAddress: [{
                    required: true,
                    message: "户籍地址不可为空",
                    trigger: "blur"
                },],
                currentAddress: [{
                    required: true,
                    message: "居住地址不可为空",
                    trigger: "blur"
                },],
                companyName: [{
                    required: true,
                    message: "单位全称不可为空",
                    trigger: "blur"
                },],
                companyCode: [{
                    required: true,
                    message: "统一信用代码不可为空",
                    trigger: "blur"
                },],
                companyAddress: [{
                    required: true,
                    message: "单位地址不可为空",
                    trigger: "blur"
                },],
                registeredRegion: [{
                    required: true,
                    message: "单位注册所在区不可为空",
                    trigger: "blur"
                },],
                attachment:[{
                    required: true,
                    validator: (rule, value, callback) => {
                        var upload1 = this.$refs.uploader1.getFiles();
                        var upload2 = this.$refs.uploader2.getFiles();
                        if(!upload1){
                            callback(new Error("请上传免冠证件照！"));
                        }
                        else if(!upload2){
                            callback(new Error("请上传身份证、户口本扫描件！"));
                        }
                        // else if(upload2 && upload2.split(',').length != 2){
                        //     callback(new Error("身份证必须要上传正反两张扫描件！"));
                        // }
                        else{
                            callback();
                        }
                    },
                }],

                beCity: [{
                    required: true,
                },],
                beRegion: [{
                    required: true,
                },],
                bePublic: [{
                    required: true,
                },],
                haveCompensation: [{
                    required: true,
                },],
                cityAdress: [{
                    required: true,
                    message: "房屋坐落地址不可为空",
                    trigger: "blur"
                },],
                cityArea: [{
                    required: true,
                    // message: "面积不可为空",
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("面积不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("面积格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                cityPropertyOwner: [{
                    required: true,
                    message: "产权人或公房承租人不可为空",
                    trigger: "blur"
                },],
                regionAdress: [{ 
                    required: true, 
                    message: "房屋坐落地址不可为空", 
                    trigger: "blur" 
                },],
                regionArea: [{ 
                    required: true, 
                    //message: "面积不可为空", 
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("面积不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("面积格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur" 
                },],
                regionPropertyOwner: [{ 
                    required: true, 
                    message: "产权人或公房承租人不可为空", 
                    trigger: "blur" 
                },],
                publicAdress: [{ 
                    required: true, 
                    message: "房屋坐落地址不可为空", 
                    trigger: "blur" 
                },],
                publicArea: [{ 
                    required: true, 
                    //message: "面积不可为空", 
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("面积不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("面积格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur" 
                },],
                publicPropertyOwner: [{ 
                    required: true, 
                    message: "产权人或公房承租人不可为空", 
                    trigger: "blur" 
                },],
                compensationArea: [{
                    required: true,
                    //message: "补偿面积不可为空",
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("补偿面积不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("补偿面积格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                areaTotal: [{
                    required: true,
                    //message: "合计建筑面积不可为空",
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("合计建筑面积不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("合计建筑面积格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                areaAvg:[{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("人均建筑面积不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("人均建筑面积格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                placementDate: [{
                    required: true,
                    message: "动迁安置时间不可为空",
                    trigger: "blur"
                },],
                compensationMoney: [{
                    required: true,
                    //message: "补偿金额不可为空",
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("补偿金额不可为空"));
                        } else if (!areaReg(value)) {
                            callback(new Error("补偿金额不可为空格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                populationTotal: [{
                    required: true,
                    //message: "核定面积家庭总人数不可为空",
                    validator: (rule, value, callback) => {
                        if (!value) {
                            callback(new Error("核定面积家庭总人数不可为空"));
                        } else if (!isPositiveInt(value)) {
                            callback(new Error("核定面积家庭总人数格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                cityPopulation:[{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("住房户籍人口总数不能为空！"));
                        } else if (!isInt(value)) {
                            callback(new Error("住房户籍人口总数输入格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                regionPopulation:[{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("住房户籍人口总数不能为空！"));
                        } else if (!isInt(value)) {
                            callback(new Error("住房户籍人口总数输入格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                publicPopulation:[{
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("住房户籍人口总数不能为空！"));
                        } else if (!isInt(value)) {
                            callback(new Error("住房户籍人口总数输入格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },],
                cityPropertyType:[
                    {required: true, message: "产权性质不可为空"}
                ],
                regionPropertyType:[
                    {required: true, message: "产权性质不可为空"}
                ],
                publicPropertyType:[
                    {required: true, message: "产权性质不可为空"}
                ],
                cityRoomType:[
                    {required: true, message: "房屋类型不可为空"}
                ],
                regionRoomType:[
                    {required: true, message: "房屋类型不可为空"}
                ],
                publicRoomType:[
                    {required: true, message: "房屋类型不可为空"}
                ],

                area:[
                    {required: true, message:"居住区不能为空"}
                ],
                months:[
                    {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("居住时限不能为空！"));
                        } else if (!isInt(value)) {
                            callback(new Error("居住时限输入格式不正确！"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                },
                ],
                isOtherAreaApply:[
                   {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (this.isOtherAreaApply === "") {
                            callback(new Error("其它区公租房入住情况必须选择！"));
                        } else if (this.isOtherAreaApply) {
                            var filter = this.areaList.find(function(el){
                                if(el.checked){
                                    return true;
                                }
                                else{
                                    return false;
                                }
                            });
                            
                            if(filter == undefined){
                                callback(new Error("请添加其它区公租房入住记录！"));
                            }
                            else{
                                callback();
                            }
                        } else {
                            callback();
                        }
                    },
                    trigger: "change"
                },
                ]
            },

            companyList:[]
        }
    },
    components:{
        MultiUploader
    },
    methods:{
        discernCertNo(){
            var certNo = this.addfamily.certNo;
            if(isIdCardNo(certNo)){
                this.addfamily.birthday = new Date(certNo.substring(6, 10) + "-" + certNo.substring(10, 12) + "-" + certNo.substring(12, 14)); 
                this.addfamily.sex = parseInt(certNo.substr(16, 1)) % 2;
            }
        },
        showaddFamily(){            
            this.addFamily=true
            this.addfamilyflag=-1
            this.init()

            // 初始化多附件控件
            this.$nextTick(()=>{
                this.$refs.addfamily.clearValidate();
                this.$refs.uploader1.init('','',1);
                this.$refs.uploader2.init('','',6);
            })
        },
        closeaddFamily(){
            this.addFamily=false
        },
        ChangeRentType(item){
            //this.getCommunityRoomKinds(this.applyInfo.rentIntentEntity.communityID,item)
            this.applyInfo.rentIntentEntity.roomKindID=''
            this.applyInfo.rentIntentEntity.communityID=''
            this.applyInfo.rentIntentEntity.streetTown=''
            this.communitylist=[]
            this.roomlist=[]
        },
        ChangeStreetTown(item){
            this.getCommunityList(item, this.applyInfo.rentIntentEntity.applyType, this.applyInfo.rentCompanyEntity.companyID)
            this.applyInfo.rentIntentEntity.communityID=''
            this.applyInfo.rentIntentEntity.roomKindID=''

        },
        ChangeCommunity(item){
            if(this.applyInfo.rentIntentEntity.rentType==null){
                this.$message({
                    message: '请选择租赁方式',
                    center: true,
                    type:"error"
                });
                return
            }
            this.getCommunityRoomKinds(item,this.applyInfo.rentIntentEntity.rentType)

            this.applyInfo.rentIntentEntity.roomKindID=''

            //福临佳苑
            if(item=='f1f7067b-1741-41d1-9f80-a6d500eb39f9'){
                this.$alert('福临佳苑只允许申请人本人入住', '提示', {confirmButtonText: '我已知晓'});
            }
        },
        //获取租赁方式列表
        getRentwayType(){
            this.rentwayList = this.$Global.enum.RentType;
        },
        // 获取小区列表
        getCommunityList(name, applyType, companyID) {
            PortalApi.getIntentCommunitys(name, applyType, companyID)
            .then(
                (res) => {
                    this.communitylist = res.data;
                    if(this.applyInfo.rentIntentEntity.rentType==2)
                    {
                        if(this.communitylist)
                        {
                            for(var i =0 ; i<this.communitylist.length;i++){
                                if(this.communitylist[i].name=='福临佳苑')
                                {
                                    this.communitylist.splice(i,1)
                                    break;
                                }
                            }
                        }
                    }
                    var communityID = this.applyInfo.rentIntentEntity.communityID;
                    if(!communityID){
                        communityID = this.$route.query.communityId;
                    }

                    if(communityID){
                        // 如果新申请，判断有无该小区权限
                        var isExist = false;
                        res.data.forEach(function(ele){
                            if(ele.id == communityID){
                                isExist = true;
                                return false;
                            }
                        });

                        if(!isExist){
                            this.applyInfo.rentIntentEntity.communityID = "";
                            this.$message({
                                type: "error",
                                message: "该小区目前只对单位员工开放申请",
                                center: true,
                            });
                        }
                    }
                },
                (err) => {
                    this.$message({
                        type: "error",
                        message: err,
                        center: true,
                    });
                }
                )
                .catch((error) => {
                this.$message({
                    type: "error",
                    message: error,
                    center: true,
                });
            });
        },
        // 获取小区房源类型
        getCommunityRoomKinds(communityid,renttype) {
            PortalApi.getIntentRoomKinds(communityid,renttype)
            .then(
            (res) => {
                this.roomlist = res.data;
            },
            (err) => {
                this.$message({
                message: err,
                center: true,
                });
            }
            )
            .catch((error) => {
            this.$message({
                message: error,
                center: true,
            });
            });
        },
        //获取街道
        getStreetTownList(){
            this.streettownlist = this.$Global.syscode.StreetTownList;
            this.getCommunityList(this.applyInfo.rentIntentEntity.streetTown, this.applyInfo.rentIntentEntity.applyType, this.applyInfo.rentCompanyEntity.companyID)
        },
        //获取性别列表
        getSexStatus(){
            this.sexlist = this.$Global.enum.AllowSex;
        },
        getCertTypeList(){
            this.certType = this.$Global.enum.CertType;
        },
        //获取婚姻状况列表
        getMarriageStatus(){
            this.marriagelist = this.$Global.enum.MaritalStatus;
        },
        //获取政治面貌列表
        getPoliticalStatus(){
            this.policylist = this.$Global.syscode.PoliticalStatus;
        },
        //获取职称列表
        getTitleStatus(){
            this.titlelist = this.$Global.syscode.Title;
        },
        //获取学历列表
        getEducationStatus(){
            this.educationlist = this.$Global.syscode.Education;
        },
        //获取职业列表
        getProfessionStatus(){
            this.positionlist = this.$Global.syscode.Profession;
        },
        //获取户口性质列表
        getIdentityTypeStatus(){
            this.identitytypelist = this.$Global.syscode.IdentityType;
        },
        //获取民族列表
        getNationStatus(){
            this.nationlist = this.$Global.syscode.Nation;
        },
        //获取关系列表
        getRelationStatus(){
            this.relationlist = this.$Global.enum.RelationPrincipal;
            if(this.applyInfo.renterFamliyList){
                for(var i =0 ; i<this.applyInfo.renterFamliyList.length;i++){
                    for(var j= 0;j<this.relationlist.length;j++){
                        if(this.applyInfo.renterFamliyList[i].relationPrincipal==this.relationlist[j].enumValue){
                            this.applyInfo.renterFamliyList[i].re=j                                      
                        }
                    }
                }
            }
            this.relationlist.splice(2,2);
        },
        //获得产权性质列表
        getPropertyType(){
            this.propertytypelist = this.$Global.enum.BuildingPropertyType;
        },
        //获得房屋类型列表
        getHousingType(){
            this.housetypelist = this.$Global.enum.CityHousingType;
        },
        //获得所在区类型列表
        getRegionList(){
            this.regionList = this.$Global.syscode.RegisteredRegion;
            console.log(this.regionList);

            // 构建区   
            var that = this;              
            var tempAreaList = [];
            if(that.apply2.otherRegionApplyInfo){
                this.isOtherAreaApply = true;
                var splitList = that.apply2.otherRegionApplyInfo.split(";");
                splitList.forEach(function(ele){
                    if(ele){
                        var arr = ele.split("|");
                        tempAreaList.push({
                            area : arr[0],
                            months : arr[1],
                        })
                    }
                })
            }else{
                this.isOtherAreaApply = false;
            }

            
            this.regionList.forEach(function(el){
                var checkedItem = tempAreaList.find(function(ele){
                    if(ele.area == el.code){
                        return true;
                    }
                    else{
                        return false;
                    }
                });

                if(el.code != "05"){
                    that.areaList.push({
                        area: el.code,
                        areaName: el.name,
                        checked : (checkedItem != undefined) ? true: false,
                        months : (checkedItem != undefined) ? checkedItem.months: ""
                    })
                }
            })
        },
        getApplyInfo(id){
            UserApi.getRentApplyInfo(id)
                .then(
                    (res) => {
                        this.applyInfo=res.data
                        
                        this.apply2.name = this.applyInfo.rentBasicEntity.name
                        this.apply2.sex = this.applyInfo.rentBasicEntity.sex
                        this.apply2.birthday = this.applyInfo.rentBasicEntity.birthday                        
                        this.apply2.maritalStatus = (this.applyInfo.rentBasicEntity.maritalStatus==='' || this.applyInfo.rentBasicEntity.maritalStatus===null)?'':parseInt(this.applyInfo.rentBasicEntity.maritalStatus) 
                        this.apply2.certNo = this.applyInfo.rentBasicEntity.certNo
                        this.apply2.telephone = this.applyInfo.rentBasicEntity.telephone
                        this.apply2.politicalStatus = this.applyInfo.rentBasicEntity.politicalStatus
                        this.apply2.mobile = this.applyInfo.rentBasicEntity.mobile
                        this.apply2.email = this.applyInfo.rentBasicEntity.email
                        this.apply2.liveAddress = this.applyInfo.rentBasicEntity.liveAddress
                        this.apply2.liveZip = this.applyInfo.rentBasicEntity.liveZip
                        this.apply2.currentAddress = this.applyInfo.rentBasicEntity.currentAddress
                        this.apply2.currentZip = this.applyInfo.rentBasicEntity.currentZip
                        this.apply2.otherRegionApplyInfo = this.applyInfo.rentBasicEntity.otherRegionApplyInfo
                        this.id = this.applyInfo.rentBasicEntity.id

                        this.apply2.education = this.applyInfo.rentQualificationsEntity.education
                        this.apply2.title = this.applyInfo.rentQualificationsEntity.title
                        this.apply2.profession = this.applyInfo.rentQualificationsEntity.profession
                        this.apply2.identityType = this.applyInfo.rentQualificationsEntity.identityType
                        this.apply2.nation = this.applyInfo.rentBasicEntity.nation
                        this.apply2.isResidenceCard = this.applyInfo.rentQualificationsEntity.isResidenceCard
                        this.apply2.isSocialSecurity = this.applyInfo.rentQualificationsEntity.isSocialSecurity
                        this.apply2.isLiveTwoYears = this.applyInfo.rentQualificationsEntity.isLiveTwoYears
                        this.apply2.isSocialSecurityGold12Month = this.applyInfo.rentQualificationsEntity.isSocialSecurityGold12Month

                        this.addfamilys=this.applyInfo.renterFamliyList
                        this.famliyroominfos=this.applyInfo.renterFamliyRoomInfoList
                        this.getCommunityList(this.applyInfo.rentIntentEntity.streetTown, this.applyInfo.rentIntentEntity.applyType, this.applyInfo.rentCompanyEntity.companyID)
                        this.getCommunityRoomKinds(this.applyInfo.rentIntentEntity.communityID,this.applyInfo.rentIntentEntity.rentType)

                        this.isCustomize = !this.applyInfo.rentCompanyEntity.isCustomize;
                        this.isKeyEnterprises=this.applyInfo.rentCompanyEntity.isKeyEnterprises;

                        if(!res.data.eidtable){
                            this.disabled=true
                        }else{
                            this.disabled=false
                        }

                        this.intentDisabled = this.disabled

                        if(res.data.isExtend){
                            this.intentDisabled = true;
                        }

                        this.getRentwayType()
                        this.getPropertyType()
                        this.getHousingType()
                        this.getStreetTownList()
                        this.getMarriageStatus()
                        this.getPoliticalStatus()
                        this.getTitleStatus()
                        this.getEducationStatus()
                        this.getProfessionStatus()
                        this.getIdentityTypeStatus()
                        this.getNationStatus()
                        this.getRelationStatus()
                        this.getSexStatus()
                        this.getCertTypeList()
                        this.getRegionList()
                    },
                    (err) => {
                    this.$message({
                        message: err,
                        center: true,
                    });
                    }
                )
                .catch((error) => {
                this.$message({
                    message: error,
                    center: true,
                });
            });
        },
        Step2(){
            if(this.addfamily.relationPrincipal!=1 && !this.addfamily.mobile)
            {
                    this.$message({
                        message: '手机不可为空',
                        center: true,
                        type:"error"
                    });

                    this.nextLoading = false;
                    return
            }
            if(this.addfamily.mobile)
            {
                if(!isMobile(this.addfamily.mobile)){
                    this.$message({
                        message: '手机号码格式不正确',
                        center: true,
                        type:"error"
                    });

                    this.nextLoading = false;
                    return
                }
            }
            if(this.addfamily.telephone)
            {
                var regPhone = new RegExp(/^[0-9()（）-]*$/);
                if(!regPhone.test(this.addfamily.telephone)){
                    this.$message({
                        message: '固定电话格式不正确',
                        center: true,
                        type:"error"
                    });

                    this.nextLoading = false;
                    return
                }
            }
            var gravatarPhotoName = this.$refs.uploader1.getFiles();
            if(gravatarPhotoName)
            {
                var fileType = gravatarPhotoName.substring(gravatarPhotoName.lastIndexOf(".") + 1);
                if(fileType.toLowerCase() != "jpg" && fileType.toLowerCase() != "jpeg" && fileType.toLowerCase() != "png"
                            && fileType.toLowerCase() != "bmp")
                {
                    this.$message({
                        message: '免冠证件照必须是图片格式',
                        center: true,
                        type:"error"
                    });

                    this.nextLoading = false;
                    return
                }
            }
            this.$refs['addfamily'].validate((valid) => {
                if (valid) {
                    for(var j= 0;j<this.relationlist.length;j++){
                        if(this.addfamily.relationPrincipal==this.relationlist[j].enumValue){
                            this.addfamily.re=j
                        }
                    }

                    this.addfamily.gravatarPhoto = this.$refs.uploader1.getFiles();
                    this.addfamily.gravatarPhotos = this.$refs.uploader1.getFileUrls();

                    this.addfamily.identityPhoto = this.$refs.uploader2.getFiles();
                    this.addfamily.identityPhotos = this.$refs.uploader2.getFileUrls();

                    var saveApply = {rentBasicEntity:{},renterFamliyList:[]};
                    saveApply.rentBasicEntity.id = this.applyInfo.rentBasicEntity.id;
                    saveApply.renterFamliyList.push(this.addfamily);
                    
                    UserApi.saveApply2(saveApply)
                        .then(
                            (res) => {
                                this.familyID=res.data
                                if(this.addfamilyflag<0){
                                    this.addfamily.id = this.familyID
                                    this.applyInfo.renterFamliyList.push(this.addfamily)
                                }
                                else{
                                    this.applyInfo.renterFamliyList[this.addfamilyflag]=this.addfamily
                                }

                                this.addstep=false
                                for(var j= 0;j<this.relationlist.length;j++){
                                    if(this.addfamily.relationPrincipal==this.relationlist[j].enumValue){
                                        this.addfamily.re=j
                                    }
                                }
                                this.addstep=false

                                this.nextLoading = false;
                            },
                            (err) => {
                                this.$message({
                                    message: err,
                                    type: "error",
                                    center: true,
                                });
                                this.nextLoading = false;
                            }
                        )
                        .catch((error) => {
                            this.$message({
                                message: error,
                                type: "error",
                                center: true,
                            });
                            this.nextLoading = false;
                        });
                }
                else{
                    this.nextLoading = false;
                }
            })
        },
        onNext(){
            if(this.disabled){
                this.$router.push({ path: '/Apply/ApplySec' ,query: {id: this.$route.query.id}});
                return
            }
            
            this.nextLoading = true;
            
            if(!this.applyInfo.rentCompanyEntity.companyName){
                this.$message({
                    message: '单位全称不能为空',
                    center: true,
                    type:"error"
                });

                this.nextLoading = false;

                return
            }

            if(!this.isCustomize){
                var reg = new RegExp(/^[0-9A-Za-z]{18}$/);
                if(!this.applyInfo.rentCompanyEntity.companyCode||this.applyInfo.rentCompanyEntity.companyCode.length!=18){
                    this.$message({
                        message: '请填写18位社会信用代码',
                        center: true,
                        type:"error"
                    });

                    this.nextLoading = false;
                    return
                }
                if(!reg.test(this.applyInfo.rentCompanyEntity.companyCode)){
                    this.$message({
                        message: '社会信用代码含有非法字符',
                        center: true,
                        type:"error"
                    });

                    this.nextLoading = false;
                    return
                }
                if(!this.applyInfo.rentCompanyEntity.companyAddress){
                    this.$message({
                        message: '单位地址不能为空',
                        center: true,
                        type:"error"
                    });

                    this.nextLoading = false;
                    return
                }
            }
            if(this.apply2.telephone)
            {
                var regPhone = new RegExp(/^[0-9()（）-]*$/);
                if(!regPhone.test(this.apply2.telephone)){
                    this.$message({
                        message: '固定电话格式不正确',
                        center: true,
                        type:"error"
                    });

                    this.nextLoading = false;
                    return
                }
            }
            //var applyType = this.applyInfo.rentIntentEntity.applyType;
            // if(applyType == "1" && !this.apply2.isLiveTwoYears && this.apply2.identityType=='02'){
            //     this.$message({
            //         message: '非本市户口，持上海市居住证不满二年不能申请',
            //         center: true,
            //         type:"error"
            //     });

            //     this.nextLoading = false;
            //     return
            // }
            // if(applyType == "1" && !this.apply2.isSocialSecurityGold12Month && this.apply2.identityType=='02'){
            //     this.$message({
            //         message: '非本市户口，申请日期前12个月若没有连续缴纳社保金将不能申请',
            //         center: true,
            //         type:"error"
            //     });

            //     this.nextLoading = false;
            //     return
            // }

            // 未婚的不能选择家庭申请方式
            if(this.apply2.maritalStatus == 0 && this.applyInfo.rentIntentEntity.rentType == 2){
                this.$message({
                    message: '未婚的，租赁方式不能选择家庭',
                    center: true,
                    type:"error"
                });

                this.nextLoading = false;
                return
            }

            // 因为个人申请必须满足社保与居住证，所以页面上默认不显示两个选项，但是保存时，保存为”是“
            // if(applyType == "1"){
            //     this.apply2.isResidenceCard = true;
            //     this.apply2.isSocialSecurity = true;
            // }

            // 本市户口，不验证居住证信息（只是为了validate校验而给的默认值）
            if(this.apply2.identityType != '02'){
                this.apply2.isResidenceCard = false;
                this.apply2.isLiveTwoYears = false;
            }

            this.applyInfo.rentCompanyEntity.isCustomize = !this.isCustomize;
            this.$refs['applyInfo1'].validate((valid) => {
                if (valid) {
                    this.$refs['apply2'].validate((valid) => {
                        if (valid) {
                            this.$refs['applyInfo3'].validate((valid) => {
                                if (valid) {
                                    this.applyInfo.rentBasicEntity = {
                                        id:this.applyInfo.rentBasicEntity.id,
                                        name:this.apply2.name,
                                        sex:this.apply2.sex,
                                        birthday:moment(this.apply2.birthday).format('YYYY-MM-DD HH:MM:SS'),
                                        maritalStatus:this.apply2.maritalStatus,
                                        certNo:this.apply2.certNo,
                                        telephone:this.apply2.telephone,
                                        politicalStatus:this.apply2.politicalStatus,
                                        mobile:this.apply2.mobile,
                                        email:this.apply2.email,
                                        liveAddress:this.apply2.liveAddress,
                                        liveZip:this.apply2.liveZip,
                                        currentAddress:this.apply2.currentAddress,
                                        currentZip:this.apply2.currentZip,
                                        nation:this.apply2.nation,
                                        dataFrom:1, // 门户来源
                                        otherRegionApplyInfo:this.apply2.otherRegionApplyInfo
                                    }
                                    this.applyInfo.rentQualificationsEntity = {
                                        education:this.apply2.education,
                                        title:this.apply2.title,
                                        profession:this.apply2.profession,
                                        identityType:this.apply2.identityType,
                                        isResidenceCard:this.apply2.isResidenceCard,
                                        isSocialSecurity:this.apply2.isSocialSecurity,
                                        isLiveTwoYears:this.apply2.isLiveTwoYears,
                                        isSocialSecurityGold12Month:this.apply2.isSocialSecurityGold12Month                                        
                                    }

                                    UserApi.saveApply1(this.applyInfo)
                                        .then(
                                            (res) => {
                                                this.applyInfo.rentBasicEntity.id=res.data
                                                if(!this.addFamily){
                                                    this.nextLoading = false;

                                                    // 检查婚姻状况，如果是“已婚”的，必须要有家庭成员信息
                                                    if(this.applyInfo.rentBasicEntity.maritalStatus == 1
                                                        && this.applyInfo.renterFamliyList.length <= 0){
                                                        this.$message({
                                                            message: '已婚的，请必须填写家庭成员信息',
                                                            center: true,
                                                            type:"error"
                                                        });

                                                        return;
                                                    }

                                                    // 检查婚姻状况，如果是“丧偶”或“离异”的，租赁方式选家庭的，必须要有家庭成员信息
                                                    if((this.applyInfo.rentBasicEntity.maritalStatus == 2
                                                        || this.applyInfo.rentBasicEntity.maritalStatus == 3)
                                                        && this.applyInfo.rentIntentEntity.rentType == 2
                                                        && this.applyInfo.renterFamliyList.length <= 0){
                                                        this.$message({
                                                            message: '租赁方式选择了家庭，请必须填写家庭成员信息',
                                                            center: true,
                                                            type:"error"
                                                        });

                                                        return;
                                                    }
                                                    
                                                    this.$router.push({ path: '/Apply/ApplySec' ,query: {id: this.applyInfo.rentBasicEntity.id}});
                                                }else if(this.addstep){
                                                    // 家庭成员保存
                                                    this.Step2()
                                                }else{
                                                    this.$message({
                                                        message: '请先完成家庭成员信息保存',
                                                        center: true,
                                                        type:"error"
                                                    });

                                                    this.nextLoading = false;
                                                }
                                            },
                                            (err) => {
                                                this.$message({
                                                    message: err,
                                                    type: "error",
                                                    center: true,
                                                });
                                                this.nextLoading = false;
                                            }
                                        )
                                        .catch((error) => {
                                            this.$message({
                                                message: error,
                                                type: "error",
                                                center: true,
                                            });
                                            this.nextLoading = false;
                                        });
                                }
                                else{
                                    this.nextLoading = false;
                                }
                            })
                        }
                        else{
                            this.nextLoading = false;
                        }
                    })
                }
                else{
                    this.nextLoading = false;
                }
            });
        },
        onNextCheck(){
             if(!this.applyInfo.rentCompanyEntity.companyName){
                this.$message({
                    message: '单位全称不能为空',
                    center: true,
                    type:"error"
                });

                return
            }

            if(!this.isCustomize){
                var reg = new RegExp(/^[0-9A-Za-z]{18}$/);
                if(!this.applyInfo.rentCompanyEntity.companyCode||this.applyInfo.rentCompanyEntity.companyCode.length!=18){
                    this.$message({
                        message: '请填写18位社会信用代码',
                        center: true,
                        type:"error"
                    });

                    return
                }
                if(!reg.test(this.applyInfo.rentCompanyEntity.companyCode)){
                    this.$message({
                        message: '社会信用代码含有非法字符',
                        center: true,
                        type:"error"
                    });

                    return
                }
                if(!this.applyInfo.rentCompanyEntity.companyAddress){
                    this.$message({
                        message: '单位地址不能为空',
                        center: true,
                        type:"error"
                    });

                    return
                }
                UserApi.checkCompanyCodeName({companyCode:this.applyInfo.rentCompanyEntity.companyCode,companyName:this.applyInfo.rentCompanyEntity.companyName})
                    .then((res)=>{
                        if(res.data)
                        {
                            this.onNext();
                        }
                    }
                    ,
                    (err) => {
                            this.$confirm(err+'，是否继续保存？', '系统提示', {
                                        distinguishCancelAndClose: true,
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消'
                                    }).then(() => {
                                       this.onNext();
                                })
                        }
                    )
                    .catch((error) => {
                         this.$message({
                               message: error,
                                type: "error",
                                center: true,
                           });
                    });
            }
            else
            {
                this.onNext();
            }
        },
        editFamily(id){
            this.addfamily=this.applyInfo.renterFamliyList[id]
            if(this.famliyroominfos.length)
                this.famliyroominfo=this.famliyroominfos[id]
            this.addfamilyflag=id
            this.addFamily=true

            // 初始化多附件控件
            this.$nextTick(()=>{                
                this.$refs.uploader1.init(this.addfamily.gravatarPhoto,this.addfamily.gravatarPhotos,1);
                this.$refs.uploader2.init(this.addfamily.identityPhoto,this.addfamily.identityPhotos,6);
            })
        },
        onPrevious(){
            this.addstep=true
            this.$nextTick(()=>{                
                this.$refs.uploader1.init(this.addfamily.gravatarPhoto,this.addfamily.gravatarPhotos,1);
                this.$refs.uploader2.init(this.addfamily.identityPhoto,this.addfamily.identityPhotos,6);
            })
        },
        onSave(){
            if(!this.famliyroominfo.beCityEntity.beCity){
                this.$refs['cityinfo1'].validate((valid) => {
                    if(valid){
                        this.$refs['cityinfo2'].validate((valid) => {
                            if(valid){
                                this.iscity=true
                            }
                        })
                    }
                })
            }else{
                this.iscity=true
            }
            if(!this.famliyroominfo.beRegionEntity.beRegion){
                this.$refs['regioninfo1'].validate((valid) => {
                    if(valid){
                        this.$refs['regioninfo2'].validate((valid) => {
                            if(valid){
                                this.isregion=true
                            }
                        })
                    }
                })
            }else{
                this.isregion=true
            }
            if(!this.famliyroominfo.bePublicEntity.bePublic){
                this.$refs['publicinfo1'].validate((valid) => {
                    if(valid){
                        this.$refs['publicinfo2'].validate((valid) => {
                            if(valid){
                                this.ispublic=true
                            }
                        })
                    }
                })
            }else{
                this.ispublic=true
            }
            if(this.famliyroominfo.haveCompensationEntity.haveCompensation){
                this.$refs['haveCompensation'].validate((valid) => {
                    if(valid){
                        this.iscompensation=true
                    }
                })
            }else{
                this.iscompensation=true
            }
            if(this.iscity&&this.isregion&&this.ispublic&&this.iscompensation){
                this.onSubmit()
                this.iscity=false
                this.isregion=false
                this.ispublic=false
                this.iscompensation=false
            }else{
                this.iscity=false
                this.isregion=false
                this.ispublic=false
                this.iscompensation=false
            }
        },
        onSubmit(){
            if(this.addfamilyflag<0){
                this.famliyroominfo.familyApplyID=this.familyID
                this.famliyroominfo.familyCertNo=this.addfamily.certNo
                this.famliyroominfo.familyName=this.addfamily.name
            }

            var data = {rentBasicEntity:{},renterFamliyRoomInfoList:[]};
            data.rentBasicEntity.id = this.applyInfo.rentBasicEntity.id;
            data.renterFamliyRoomInfoList.push(this.famliyroominfo)
            
            UserApi.saveApply3(data)
                .then(
                    () => {
                        // 保存成功后，再更新数组
                        if(this.addfamilyflag<0){
                            this.famliyroominfos.push(this.famliyroominfo)
                        }
                        else{
                            this.famliyroominfos[this.addfamilyflag]=this.famliyroominfo
                        }

                        this.addFamily=false
                        this.addstep=true,
                        this.init()
                    },
                    (err) => {
                    this.$message({
                        message: err,
                        type: "error",
                        center: true,
                    });
                    }
                )
                .catch((error) => {
                this.$message({
                    message: error,
                    type: "error",
                    center: true,
                });
            });
        },
        onDelete(index,id){
            this.$confirm('是否确定删除？', '系统提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                UserApi.deleteRentCoapplicant(id)
                .then(() => {
                        //le.log(res)
                        this.addFamily=false;
                        if(this.applyInfo.renterFamliyList.length)
                            this.applyInfo.renterFamliyList.splice(index,1)
                        if(this.applyInfo.renterFamliyRoomInfoList.length)
                            this.applyInfo.renterFamliyRoomInfoList.splice(index,1)
                    },
                    (err) => {
                    this.$message({
                        message: err,
                        type: "error",
                        center: true,
                    });
                    }
                )
                .catch((error) => {
                    this.$message({
                        message: error,
                        type: "error",
                        center: true,
                    });
                });
            })
        },
        init(){
            this.addfamily={
                id:'',
                name:'',
                sex:'',
                certNo:'',
                birthday:'',
                maritalStatus:'',
                relationPrincipal:'',
                politicalStatus:'',
                telephone:'',
                mobile:'',
                isSocialSecurityGold12Month:false,
                isLiveTwoYears:false,
                identityType:'',
                liveAddress:'',
                email:'',
                isChummage:true,
                gravatarPhoto:'',
                gravatarPhotos:[],
                identityPhoto:'',
                identityPhotos:[],
            },
            this.famliyroominfo={
                beCityEntity:{
                    beCity: 1,
                    cityAdress: null,
                    cityArea: null,
                    cityPopulation: null,
                    cityPropertyOwner: null,
                    cityPropertyType: null,
                    cityRemark: null,
                    cityRoomType: null,
                    cityAreaType:null
                },
                beRegionEntity:{
                    beRegion: 1,
                    regionAdress: null,
                    regionArea: null,
                    regionPopulation: null,
                    regionPropertyOwner: null,
                    regionPropertyType: null,
                    regionRemark: null,
                    regionRoomType: null,
                    regionAreaType:null
                },
                bePublicEntity:{
                    bePublic: 1,
                    publicAdress: null,
                    publicArea: null,
                    publicPopulation: null,
                    publicPropertyOwner: null,
                    publicPropertyType: null,
                    publicRemark: null,
                    publicRoomType: null,
                    publicAreaType:null
                },
                haveCompensationEntity:{
                    areaAvg: null,
                    areaTotal: null,
                    compensationArea: null,
                    compensationMoney: null,
                    haveCompensation: false,
                    placementDate: null,
                    populationTotal: null,
                },
                familyApplyID: "",
                familyCertNo: "",
                familyName: "",
            }
        },
        // 获取公司列表
        getCompanyList(){
            PublicApi.getCompanyList()
            .then(
                res=>{
                    this.companyList = res.data;
                }
            )
        },
        companyChange(companyName){
            var that = this;
            that.companyList.forEach(function(ele){
                if(ele.companyName==companyName){
                    that.applyInfo.rentCompanyEntity.companyID = ele.id;
                    that.applyInfo.rentCompanyEntity.companyName = ele.companyName;
                    that.applyInfo.rentCompanyEntity.companyCode = ele.companyCode;
                    that.applyInfo.rentCompanyEntity.companyAddress = ele.address;
                    that.applyInfo.rentCompanyEntity.companyPhone = ele.telephone;
                    that.applyInfo.rentCompanyEntity.companyZip = ele.zip;
                    that.applyInfo.rentCompanyEntity.companyType = ele.companyType;
                    that.applyInfo.rentCompanyEntity.licenseNo = ele.licenseNo;
                    that.applyInfo.rentCompanyEntity.taxRegisterNo = ele.taxRegisterNo;
                    that.applyInfo.rentCompanyEntity.registeredRegion = ele.registeredRegion;
                    
                    // 更换了单位，重新获取一下小区列表（如果下面的街镇还未选，则不重新获取）
                    if(that.applyInfo.rentIntentEntity.streetTown && !that.intentDisabled){
                        that.getCommunityList(that.applyInfo.rentIntentEntity.streetTown, that.applyInfo.rentIntentEntity.applyType, ele.id);
                        //that.applyInfo.rentIntentEntity.communityID=''
                        //that.applyInfo.rentIntentEntity.roomKindID=''
                    }
                    if(ele.isKeyEnterprises==true){
                        that.isKeyEnterprises=true;
                    }
                    else
                    {
                        that.isKeyEnterprises=false;
                    }

                }
            })
        },
        changeCustomize(){
            this.isCustomize = !this.isCustomize;
            this.applyInfo.rentCompanyEntity.companyID = "";
            this.applyInfo.rentCompanyEntity.companyName = "";
            this.applyInfo.rentCompanyEntity.companyCode = "";
            this.applyInfo.rentCompanyEntity.companyAddress = "";
            this.applyInfo.rentCompanyEntity.companyPhone = "";
            this.applyInfo.rentCompanyEntity.companyZip = "";
            this.applyInfo.rentCompanyEntity.companyType = "";
            this.applyInfo.rentCompanyEntity.licenseNo = "";
            this.applyInfo.rentCompanyEntity.taxRegisterNo = "";
            this.applyInfo.rentCompanyEntity.registeredRegion = "";

            if(!this.intentDisabled){
                this.applyInfo.rentIntentEntity.communityID=''
                this.applyInfo.rentIntentEntity.roomKindID=''
            }
        },
        applyTypeChange(){
            this.isCustomize = true;
            this.applyInfo.rentIntentEntity.isApplyTalent = false;
            this.applyInfo.rentCompanyEntity.companyID = "";
            this.applyInfo.rentCompanyEntity.companyName = "";
            this.applyInfo.rentCompanyEntity.companyCode = "";
            this.applyInfo.rentCompanyEntity.companyAddress = "";
            this.applyInfo.rentCompanyEntity.companyPhone = "";
            this.applyInfo.rentCompanyEntity.companyZip = "";
            this.applyInfo.rentCompanyEntity.companyType = "";
            this.applyInfo.rentCompanyEntity.licenseNo = "";
            this.applyInfo.rentCompanyEntity.taxRegisterNo = "";
        },
        // 添加其它区的入住年限记录
        addOtherArea(){
            // 先构建一个ModelList
            if(!this.areaList || this.areaList.length <= 0){
                var that = this;
                this.regionList.forEach(function(ele){
                    if(ele.code != "05"){
                        that.areaList.push({
                            area : ele.code,
                            areaName : ele.name,
                            checked : false,
                            months : ""
                        });
                    }
                });
            }

            this.showAreaDialog = true;
        },
        confirmAdd(){
            var areaString = "";
            var isError = false;
            if(this.isOtherAreaApply && this.areaList && this.areaList.length > 0){
                this.areaList.forEach(function(ele){
                    if(ele.checked){
                        if(!ele.months){
                            isError = true;
                            return false;
                        }
                        areaString += ele.area + "|" + ele.months + ";"
                    }
                });
            }

            if(isError){
                this.$message({
                    message: "选择的区必须填写入住期数",
                    type: "error",
                    center: true,
                });
                return;
            }

            this.apply2.otherRegionApplyInfo = areaString;

            this.showAreaDialog = false;
        }
    },
    activated(){
        if(this.$route.query.communityId){
            // 新申请，所有数据清空
            this.applyInfo.rentBasicEntity = {
                id:'',
                name:'',
                sex:'',
                birthday:'',
                maritalStatus:'',
                certNo:'',
                nation:'',
                politicalStatus:'',
                telephone:'',
                mobile:'',
                email:'',
                liveAddress:'',
                liveZip:'',
                currentAddress:'',
                currentZip:''                
            }

            this.applyInfo.rentIntentEntity = {
                applyType: 1,
                communityID:this.$route.query.communityId,
                rentType: null,
                roomKindID: '',
                streetTown: this.$route.query.streetTown,
                preferences:'',
                isApplyTalent:false
            }

            this.applyInfo.rentCompanyEntity = {
                companyID:'',
                companyName:'',
                companyCode:'',
                companyAddress:'',
                companyZip:'',
                companyPhone:'',
                companyType:'',
                licenseNo:'',
                taxRegisterNo:'',
                registeredRegion:'',
                isCustomize:true
            }

            this.applyInfo.renterFamliyList = [];
            this.applyInfo.rentQualificationsEntity = {
                education:'',
                title:'',
                identityType:'',
                position:'',
                isLiveTwoYears:null,
                isSocialSecurityGold12Month:null,
                isResidenceCard:null,
                isSocialSecurity:null
            }
        }        
        if(this.$route.query.id){
            this.getApplyInfo(this.$route.query.id)
        }else{
            this.disabled=false;
            this.intentDisabled = false;
            getUserInfo().then((user) => {
                this.userInfo = user;
                this.apply2.mobile=this.userInfo.mobile
                this.apply2.name=this.userInfo.name
                this.apply2.certNo=this.userInfo.certNo
                this.apply2.sex=this.userInfo.sex
                this.apply2.maritalStatus=(this.userInfo.maritalStatus=='' || this.userInfo.maritalStatus==null)?'':parseInt(this.userInfo.maritalStatus) 
                this.apply2.birthday=moment(this.userInfo.birthDay).format('YYYY-MM-DD'),
                this.apply2.politicalStatus=this.userInfo.politicalStatus
                this.apply2.email=this.userInfo.email
                this.apply2.nation=this.userInfo.nation
                this.apply2.title=this.userInfo.title
                this.apply2.identityType=this.userInfo.identityType
                this.apply2.liveAddress=this.userInfo.liveAddress
                this.apply2.liveZip=this.userInfo.liveZip
                this.apply2.currentAddress=this.userInfo.currentAddress
                this.apply2.currentZip=this.userInfo.currentZip
                this.apply2.telephone=this.userInfo.telephone
            });
            this.getRentwayType()
            this.getPropertyType()
            this.getHousingType()
            this.getStreetTownList()
            this.getMarriageStatus()
            this.getPoliticalStatus()
            this.getTitleStatus()
            this.getEducationStatus()
            this.getProfessionStatus()
            this.getIdentityTypeStatus()
            this.getNationStatus()
            this.getRelationStatus()
            this.getSexStatus()
            this.getCertTypeList()
            this.getRegionList()
        }
        this.getCompanyList();
        this.companyChange();
        this.isCustomize = true;
    }
}
</script>

<style scoped>
.apply-part{
    margin: 0 38px;
}
.apply-part-title{
    display: flex;
    align-items: center;
}
.blue-sign{
    width: 7px;
    height: 22px;
    background: #3B93EF;
    border: 1px solid #F1F1F1;
    border-radius: 3px;
}
.apply-part-title span{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    line-height: 18px;
    margin-left: 15px;
}
/* .appinput >>> .el-input__inner{
    width: 59.4%;
}
.picker>>>.el-input__inner{
    width: 59.4%;
} */
.add-family{
    background: #F9F9F9;
    width: 100%;
}
.avatar-uploader{
    background: #FFFFFF;
    width: 132px;
    height: 106px;
    border: 1px dashed #d9d9d9;
}
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 132px;
    height: 106px;
    line-height: 106px;
    text-align: center;
    border: none;
}
.avatar {
    width: 132px;
    height: 106px;
    display: block;
}
.compantip>>>.el-form-item__content{
    display: flex;
}
.compantip>>>.el-input.el-input--small{
    width: 400px;
}
.bottomdivider{
    margin-top:30px
}
.applystep >>>.is-process .is-text{
    background: #21A66D;
    border: none;
    color: #fff;
}
.applystep >>>.is-wait .is-text{
    background: #D0D0D0;
    border: none;
    color: #fff;
}
.applystep >>>.is-success .el-step__line{
    background: #21A66D;
}
.applystep >>>.is-success .is-text{
    color: #21A66D;
    border-color:#21A66D;
}
.applystep >>>.el-step__line{
    height: 8px;
    top :6px;
}
.applystep >>>.el-step__title{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
.relationunit{
    position: relative;
    color: #999999;
    border: 1px solid #999999;
    width: 100px;
    padding: 0 10px;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
    margin-right: 20px;
}
.areaunit{
    position: relative;
    color: #999999;
    border-bottom: 1px solid #999999;
    width: 100px;
    padding: 0 10px;
    text-align: center;
    margin-right: 20px;
}

.addhouseremark>>>.el-textarea__inner{
    width: 103.2%;
}
/* .appinput1 >>> .el-input__inner{
    width: 69.2%;
} */
.rightlabel >>> .el-input{
    width: auto;
}
.overlabel >>> .el-form-item__label{
    line-height: 14px;
}
.blueclose{
    position: absolute;
    right: -8px;
    top: -8px;
}
.applyType{
    margin-left: 130px;
    margin-bottom: 20px;
}
.keyEnterprises{
    margin-left: 160px;
    margin-top: 0px;
    margin-bottom: 5px;
}
</style>